"use client";

import CartItem from "@/components/Cart/CartItem/CartItem";
import { FC } from "react";
import styles from "./CartProducts.module.scss";
import { BlendedItems } from "@/providers/CartContextProvider";

interface CartProductsProps {
	blendedItems: BlendedItems[];
	searchSpringId: string;
}

export const CartProducts: FC<CartProductsProps> = ({
	blendedItems,
	searchSpringId,
}) => {
	return (
		<div className={styles.items}>
			{blendedItems.map(({ item, product }) => {
				const isParent = product.productClass.toLowerCase() === "parent";
				if (isParent) {
					return null;
				}
				return (
					<CartItem
						key={item.id}
						item={item}
						product={product}
						searchSpringId={searchSpringId}
					/>
				);
			})}
		</div>
	);
};
